<fin-fare-family-table
  [fareFamilies]="fareFamilies"
  [showKoreaNotification]="showKoreaNotification"
  [hasWideBodyAircraft]="hasWideBodyAircraft"
/>

<article class="font-body-1 font-body-medium">
  <section class="mr-xsmall-t">
    <div
      class="ticket-type-rules-info nordic-blue-900-text text-icon-primary mr-medium-y ms-medium-x font-body-1 font-body-medium"
      [innerHTML]="'bookingSearch.boundSelection.rulesMayVary' | finLocalization | finSafe: 'html'"
    ></div>
    <fcom-notification *ngIf="hasBusLeg" class="block mr-xsmall-b">
      {{ 'bookingSearch.boundSelection.ticketTypeBusNotification' | finLocalization }}
    </fcom-notification>
    <fin-expand
      [id]="'generalFareFamilyRulesAndRestrictions'"
      [key]="'generalFareFamilyRulesAndRestrictions'"
      [finElemTracker]="'benefits-more-information'"
      [finElemContext]="TRACKING_CONTEXT"
      [finElemType]="ElementTypes.ACCORDION"
      #expand
    >
      <div class="trigger">
        <div class="nordic-blue-900-text text-icon-primary">
          <h3 class="font-heading-3 float-left font-headline-small">
            {{ 'bookingSearch.boundSelection.informationAboutBenefits' | finLocalization }}
          </h3>
          <fcom-icon
            class="inline-block rotate float-right icon-medium"
            [class.rotate-active]="expand.isOpen$ | async"
            [name]="SvgLibraryIcon.CHEVRON_DOWN"
          />
        </div>
      </div>
      <div class="content pr-medium-y">
        <cms-unstyled-fragment
          class="benefits-information"
          [contentUrl$]="'fragments.benefitsInformation.url' | finLocalization | finToObservable"
        />
      </div>
    </fin-expand>
  </section>
</article>
